import React from 'react';
import NavBar from '../NavBar';
import OpenAccount from '../OpenAccount';
import Awards from './Awards';
import Education from './Education';
import Hero from './Hero';
import Pricing from './Pricing';
import Stats from './Stats';
import Footer from '../Footer';

function HomePage() {
    return (
        <>
            
            <Hero />
            <Awards />
            <Stats />
            <Pricing />
            <Education />
            <OpenAccount />

        </>
    );
}

export default HomePage;
